export { default as Base } from './Privacy'
